module.exports = __webpack_public_path__ + "static/extravert-logo-e8e4de94184100d830d68a9406877667.png";